import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from "react";
import { Input, Select, Spin } from 'antd';
import { LoadingOutlined, } from '@ant-design/icons';
import CustomSelect from '../../../com/select/CustomLabelSelect';

import './index.scss';

const HeaderSearch = forwardRef(({
    options = {}, // input参数
    conditionList = [], // 查询条件列表
    onSearch = () => { }, // 查询回调
    loading = false, // 加载状态
    scrollTop = 0, // 滚动距离
    isShowSearch = true, // 是否显示输入框
    filterList = [], // 下拉框式  查询条件列表
    scrollHeight = 275, // 滚动高度
    word = undefined, // 搜索关键词
}, ref) => {
    const [keyword, setKeyword] = useState(word || undefined);
    const [params, setParams] = useState({});
    const [isShowFixed, setIsShowFixed] = useState(false);
    const headSearchRef = useRef(null);

    // 点击查询条件
    const handleChangeParams = (value, props) => {
        let obj = {
            ...params,
        }
        if (props === 'SAL' || props === 'REQAGE') {
            if (value && value.length > 0) {
                obj[props + 'FROM'] = value[0].split(",")[0];
                obj[props + 'TO'] = value[0].split(",")[1];
                obj[props] = value;
            } else {
                obj[props + 'FROM'] = undefined;
                obj[props + 'TO'] = undefined;
                obj[props] = [];
            }
        } else {
            obj[props] = value;
        }
        setParams(obj);

        if (onSearch) {
            onSearch({
                ...obj,
                keyword,
            });
        }
    }
    //  input回车
    const handlePressEnter = (e) => {
        if (onSearch) {
            onSearch({
                ...params,
                keyword,
            });
        }
    }

    const clearSearch = () => {
        setKeyword(undefined);
        setParams({});
        if (onSearch) {
            onSearch({});
        }
    }
    // 获取检索元素的高度
    useImperativeHandle(ref, () => ({
        dom: headSearchRef && headSearchRef.current ? headSearchRef.current.offsetHeight : 0
    }));

    useEffect(() => {
             setKeyword(word ?? undefined);
        if (scrollTop > scrollHeight) {
            setIsShowFixed(true);
        } else {
            setIsShowFixed(false);
        }

    }, [scrollTop, word]);



    return (
        <div ref={headSearchRef} className="enterprise-header-search-wrap">
            <Spin spinning={loading} indicator={<LoadingOutlined />}>
                <div className="header-search">
                    {
                        isShowSearch
                            ? <div className="header-search-box">
                                <Input
                                    addonBefore={options.addonBefore ?? undefined}
                                    suffix={options.suffix ?? undefined}
                                    defaultValue={keyword}
                                    value={keyword}
                                    placeholder={options.placeholder || '请输入'}
                                    onChange={(e) => setKeyword(e.target.value && e.target.value !== '' ? e.target.value : undefined)}
                                    onPressEnter={(e) => handlePressEnter(e)}
                                />
                                <div className="header-search-btn" onClick={() => handlePressEnter()}>搜索</div>
                            </div>
                            : <></>
                    }
                    <div className="header-search-condition">
                        {
                            conditionList.map((item, index) => {
                                return (
                                    <div className="header-search-condition-item" key={index}>
                                        <label style={{ width: options.labelWidth || '100px', }}>{item.label}：</label>
                                        <ul style={{ width: `calc(100% - ${options.labelWidth || "100px"})` }}>
                                            <li
                                                className={params[item.props] && params[item.props] !== '' ? "" : "condition-item-value-active"}
                                                onClick={() => {
                                                    handleChangeParams(undefined, item.props)
                                                }}
                                            >不限</li>
                                            {
                                                item.options.map((vitem, vindex) => {
                                                    return (
                                                        <li
                                                            key={vindex}
                                                            onClick={() => {
                                                                handleChangeParams(item.props == 'JOBTYPE' ? [vitem[item.valueProps]] : vitem[item.valueProps], item.props)
                                                            }}
                                                            className={params[item.props] && params[item.props] == vitem[item.valueProps] ? "header-search-condition-item-value condition-item-value-active" : "header-search-condition-item-value"}
                                                        >{vitem.name}</li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                )
                            })
                        }

                        <div className="header-search-btn-wrap">
                            <div className="header-search-btn-filter">
                                {
                                    filterList && filterList.map((item) => {
                                        return <CustomSelect
                                            options={item?.options}
                                            mode={item?.mode}
                                            value={params[item?.props]}
                                            onChange={(value) => handleChangeParams(value, item.props)}
                                            className="w-full"
                                            customLabel={item?.label}
                                        />
                                    })
                                }
                            </div>
                            <div className="header-search-btn-clear" onClick={() => clearSearch()}>清空筛选条件</div>
                        </div>
                    </div>
                </div>
            </Spin>
            {
                isShowFixed
                    ? <div className="enterprise-header-search-fixed">
                        <div className="header-search">
                            {
                                isShowSearch
                                    ?
                                    <div className="header-search-box">
                                        <Input
                                            addonBefore={options.addonBefore ?? undefined}
                                            suffix={options.suffix ?? undefined}
                                            defaultValue={keyword}
                                            value={keyword}
                                            placeholder={options.placeholder || '请输入'}
                                            onChange={(e) => setKeyword(e.target.value && e.target.value !== '' ? e.target.value : undefined)}
                                            onPressEnter={(e) => handlePressEnter(e)}
                                        />
                                        <div className="header-search-btn" onClick={() => handlePressEnter()}>搜索</div>
                                    </div>
                                    : <></>
                            }
                            <div className="header-search-fixed-filter">
                                {
                                    conditionList.map((item, index) => {
                                        return <>
                                            <CustomSelect
                                                options={item.options.map(oitem => {
                                                    return {
                                                        label: oitem[item.nameProps || 'name'],
                                                        value: oitem[item.valueProps || 'value'],
                                                    }
                                                })}
                                                mode={item?.mode}
                                                value={params[item?.props]}
                                                onChange={(value) => handleChangeParams(value, item.props)}
                                                className="w-full"
                                                customLabel={item?.label}
                                            />
                                        </>
                                    })
                                }
                                {
                                    filterList && filterList.map((item) => {
                                        return <CustomSelect
                                            options={item?.options}
                                            mode={item?.mode}
                                            value={params[item?.props]}
                                            onChange={(value) => handleChangeParams(value, item.props)}
                                            className="w-full"
                                            customLabel={item?.label}
                                        />
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    : <></>
            }
        </div>
    );
})

export default HeaderSearch;